import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaBrowser, WeaTools } from "ecCom";

@observer
export default class BrowserItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    const showDropMenu =
      c.browserConditionParam &&
      (c.browserConditionParam.type == "4" ||
        c.browserConditionParam.type == "164"); //部门分部显示维度菜单
    if (c.browserConditionParam && c.browserConditionParam.replaceDatas) {
      delete c.browserConditionParam.replaceDatas; // 删掉默认的配置，读取form的值
    }
    return (
      <WeaBrowser
        layout={WeaTools.WindowFunc.getTop().document.body}
        showDropMenu={showDropMenu}
        {...bindObj.bind()}
        {...c.browserConditionParam}
        onChange={this.onChange}
        {...c}
        replaceDatas={toJS(bindObj.valueObj)}
        {...c.otherParams}
        mr0
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/BrowserItem.js